import { Component } from '@angular/core';

import { AuthState } from '../auth/auth.model';
import { AuthService } from '../auth/auth.service';
import {
    takeUntilDestroy,
    TakeUntilDestroy,
} from '../common/take-until-destroy.decorator';

@Component({
    selector: 'cmps-debug-panel',
    templateUrl: './panel.debug.component.html',
})
@TakeUntilDestroy()
export class DebugPanelComponent {
    /** @private */
    _build = CMPS_APP_DEF.BUILD;

    /** @private */
    _isVisible: boolean;

    /** @private */
    get _hasSaml2AuthMethod(): boolean {
        try {
            return this._authService.user.hasSaml2AuthMethod();
        } catch (err) {}
        return false;
    }

    constructor(private readonly _authService: AuthService) {
        this._isVisible = false;
    }

    /** @private */
    _onDocumentKeydown($event: KeyboardEvent): void {
        if ($event.ctrlKey && $event.altKey && $event.keyCode === 68 /* d */) {
            this._isVisible = !this._isVisible;
        }
    }

    /** @private */
    _onMoveClick(containerRef: HTMLElement, left: boolean): void {
        containerRef.classList.remove(
            'cmps-cdk-pos-left-0',
            'cmps-cdk-pos-right-0',
        );
        containerRef.classList.add(
            left ? 'cmps-cdk-pos-left-0' : 'cmps-cdk-pos-right-0',
        );
    }

    /** @private */
    _onInvokeReAuthClick(): void {
        this._authService
            .refreshToken()
            .pipe(takeUntilDestroy(this))
            .subscribe();
    }

    /** @private */
    _onInvokeTimeoutClick(): void {
        this._authService.updateAuthStatus(AuthState.TIMEOUT);
    }

    /** @private */
    _onInvokeAuthLostClick(): void {
        this._authService.updateAuthStatus(AuthState.LOST);
    }

    /** @private */
    _onToggleSsoSimulationClick(): void {
        const amr = this._authService.user.amr;
        if (amr == null) {
            return;
        }
        const indexSim = amr.indexOf('SIMULATION');
        if (indexSim === -1) {
            amr.push('SIMULATION', 'saml2');
        } else {
            amr.splice(indexSim, 1);
            const index = amr.indexOf('saml2');
            if (index !== -1) {
                amr.splice(index, 1);
            }
        }
    }
}
